// What a request may carry (Oct 18: a renter's request pitched a stays
// business to an owner, with an @handle and a website). Links, websites,
// @handles, emails and payment details are refused; links to our own sites
// are fine; phone numbers are still allowed (renters type their own
// WhatsApp; Felipe decides). The database refuses the same
// (contact_requests_message_guard, has_contact_or_link in
// scripts/migrate/new-project-request-screening-2026-10-18.sql), so the page
// can say it before sending. Pure, no Deno: the listing page imports it too.
// Tested in src/test/requestScreen.test.ts.

export const REQUEST_CONTACT_ERROR =
  "Links, @handles, emails and payment details can't go in a request. Contact details are shared once it's accepted.";

const LINK_OR_HANDLE = [
  /(https?:\/\/|www\.|wa\.me\/)/i,
  /\b[a-z0-9-]+\.(com|net|org|io|co|cr|es|me|info|biz|app|link|ly)\b/i,
  /(^|\s)@[a-z0-9_.]{3,}/i,
];
const EMAIL = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i;
const PAYMENT =
  /(^|[^a-z])(sinpe(\s*m[oó]vil)?|western\s+union|moneygram|zelle|venmo|paypal|bitcoin|crypto|wire\s+transfer|bank\s+transfer|transferencia|dep[oó]sito\s+(a|en)|pay\s+(the\s+)?(deposit|rent)\s+(to|via|by)|send\s+(the\s+)?(money|payment|deposit))([^a-z]|$)/i;
const DATES = /\b\d{4}-\d{2}-\d{2}\b|\b\d{1,2}\/\d{1,2}\/\d{2,4}\b/g;

/** "mysantateresahome.com" from "https://www.mysantateresahome.com". */
export const siteHost = (url: string): string => url.replace(/^https?:\/\/(www\.)?/i, "").replace(/\/.*$/, "").toLowerCase();

const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** The text without links to our own sites (they are always fine). */
export const stripOwnLinks = (text: string, ownHosts: string[]): string =>
  ownHosts.filter(Boolean).reduce(
    (s, h) => s.replace(new RegExp(`(https?://)?(www\\.)?${escape(h)}(/\\S*)?`, "gi"), " "),
    text ?? "",
  );

/** Links, websites and @handles (what a renter/owner chat may not carry). */
export const hasLinkOrHandle = (text: string, ownHosts: string[] = []): boolean => {
  const s = stripOwnLinks(text, ownHosts);
  return LINK_OR_HANDLE.some((re) => re.test(s));
};

/** Everything a request may not carry. */
export const requestHasContact = (text: string, ownHosts: string[] = []): boolean => {
  if (hasLinkOrHandle(text, ownHosts)) return true;
  const d = (text ?? "").replace(DATES, " ");
  return EMAIL.test(d) || PAYMENT.test(d);
};
